import React, { useEffect } from 'react';
import { Box, Button, Grid, IconButton, Slider, Typography } from '@mui/material';
import HEADPHONES from '../../assets/images/headphones.svg'
import audioGif from "../../assets/images/audio.gif";
import play from "../../assets/images/play.svg";
import music from "../../assets/images/Music.svg";
import noise from "../../assets/images/noise.svg";
import pause from "../../assets/images/pause button.svg";


const PhaseFiveUI = ({onSubmit, handlePlayPauseNoise, isNoisePlaying, setIsNoisePlaying,setSelectedNoise, selectedNoise}) => {

  
  return (
    <>
    <Box sx={{display:'flex', flexDirection:'column', alignItems:'center', height:'20vh'}}>
  <Typography  mb={4} className='AxiformaBold' align="center" fontWeight={700} fontSize={'32px'} color={"#5E5E5E"}>
  Adjust the loudness slider until it matches the volume of your tinnitus
  </Typography>
<Box mt={5} mb={2} sx={{display:'flex' , flexDirection:'column', width:'70%', alignItems:'center', justifyContent:'center'}}>
  <Box mb={4}> {isNoisePlaying ?(<img src={audioGif} style={{width:'6vw', height:'8vh', m:5}} >
    </img>) : (<img src={music} style={{width:'20vw', height:'10vh', m:2}}>
    </img>)}</Box>
    <iconButton
      variant="outlined"
    
      onClick={handlePlayPauseNoise}
      >
      <img
        src={isNoisePlaying ? pause : play}
        alt="Toggle Noise"
        style={{ width: "60px", height: "60px" }}
      />
    </iconButton>
            <Box sx={{ display: 'flex', gap: 4, justifyContent: 'space-evenly', alignContent: 'center', mt: 4 }}>
  <Button
    variant="outlined"
    onClick={() => setSelectedNoise ("white")}
    sx={{
      borderColor:  selectedNoise === "white" ? "#D34646" : '#DEDEDE',
      borderRadius: "4px",
      height: "150px",
      width: "150px",
      borderWidth: "2px",
      background:  selectedNoise === "white" ? "#FEF7F6" : ''
    }}
  >
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <img
        src={noise}
        style={{ width: "8vw", height: "12vh" }}
      />
      <Typography className='AxiformaRegular' sx={{color:'#424242', fontSize:'14px'}}>
        White Noise
      </Typography>
    </Box>
  </Button>

  <Button
    variant="outlined"
    onClick={() => setSelectedNoise ("pink")}
    sx={{
      borderColor:  selectedNoise === "pink" ? "#D34646" : '#DEDEDE',
      borderRadius: "4px",
      height: "150px",
      width: "150px",
      borderWidth: "2px",
      background:  selectedNoise === "pink" ? "#FEF7F6" : ''
    }}
  >
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <img
        src={noise}
        style={{ width: "8vw", height: "12vh" }}
      />
      <Typography className='AxiformaRegular' sx={{color:'#424242', fontSize:'14px'}}>
        Pink Noise
      </Typography>
    </Box>
  </Button>

  <Button
    variant="outlined"
    onClick={() => setSelectedNoise ("brown")}
    sx={{
      borderColor:  selectedNoise ==='brown' ? '#D34646' : '#DEDEDE',
      borderRadius: "4px",
      height: "150px",
      width: "150px",
      borderWidth: "2px",
      background:  selectedNoise === "brown" ? "#FEF7F6" : ''
    }}
  >
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <img
        src={noise}
        style={{ width: "8vw", height: "12vh" }}
      />
      <Typography className='AxiformaRegular' sx={{color:'#424242', fontSize:'14px'}}>
        Brown Noise
      </Typography>
    </Box>
  </Button>
</Box>
           
    </Box>
   
    <Button  onClick={onSubmit} sx={{width:'30vw', height:'12vh',background:'#424242', radius:'8px', alignItems:'center', color:'white', marginTop:'30px'}} >
      <Typography sx={{fontSize:'24px'}}>Finish Test</Typography>  
    </Button>

  </Box>
    </>
  
)}

export default PhaseFiveUI;
